import { createAction } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from './store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const revertAllAvailableSlicesForMassRevert = createAction('REVERT_ALL_AVAILABLE_SLICES_FOR_MASS_REVERT');
